import React, { useState } from "react";
import star from "../../../assets/images/star.png";
import banner from "../../../assets/images/first-illu.gif";
import { ReactComponent as ManagedService } from "../../../assets/svg/managed-service.svg";
import { ReactComponent as Devops } from "../../../assets/svg/devops.svg";
import { ReactComponent as DataNetwork } from "../../../assets/svg/infra-as-code.svg";
import { ReactComponent as Auditing } from "../../../assets/svg/it-auditing.svg";
import { ReactComponent as InfraAsCode } from "../../../assets/svg/data-networking.svg";
import { ReactComponent as FinanceIcon } from "../../../assets/svg/finance.svg";
import { ReactComponent as SecurityEdge } from "../../../assets/svg/security.svg";
import { ReactComponent as Automation } from "../../../assets/svg/automation.svg";
import { ReactComponent as InfraStructure } from "../../../assets/svg/infrastructure.svg";
import { ReactComponent as Manufacturing } from "../../../assets/svg/manufacture.svg";
import { ReactComponent as Healthcare } from "../../../assets/svg/health.svg";
import { ReactComponent as AUtomobile } from "../../../assets/svg/automobile.svg";
import { ReactComponent as Banking } from "../../../assets/svg/banking.svg";
import { ReactComponent as RealEstate } from "../../../assets/svg/real-estate.svg";
import { ReactComponent as Insurance } from "../../../assets/svg/insurance.svg";
import { ReactComponent as OurRecentStory } from "../../../assets/svg/recent-story.svg";
import { ReactComponent as Arrow } from "../../../assets/svg/arrow.svg";

import HomeImage from "../../../assets/images/home-illu.gif";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
const Home = () => {
  const [slideIndex, setSlideIndex] = useState(0);
  const serviceHomePageJson = [
    {
      icon: ManagedService,
      iconBackgroundColor: "#80c54d",
      cardTitle: "Website Development",
      cardContent:
        "At Pixel Dot IT Solution, we build high-performance, responsive websites tailored to your business needs. Our website development services ensure seamless functionality, fast load times, and scalable architecture to support your growth and provide exceptional user experiences.",
      navigationLink: "/services/websitedevelopment",
    },
    {
      icon: InfraAsCode,
      iconBackgroundColor: "#6223C5",
      cardTitle: "App Development",
      cardContent:
        "Our app development services at Pixel Dot IT Solution focus on creating robust, scalable, and user-friendly applications. From concept to deployment, we design apps that deliver superior performance and user engagement, helping businesses expand their digital reach effectively.",
      navigationLink: "/services/appdevelopment",
    },
    {
      icon: Devops,
      iconBackgroundColor: "#ca8220",
      cardTitle: "UI/UX Design",
      cardContent:
        "At Pixel Dot IT Solution, we specialize in crafting intuitive UI/UX designs that enhance user experiences. Our design approach focuses on creating visually stunning and easy-to-navigate interfaces that increase engagement and ensure user satisfaction across all platforms.",
      navigationLink: "/services/uiuxdesign",
    },
    {
      icon: Automation,
      iconBackgroundColor: "#de6742",
      cardTitle: "Custom Web Solution",
      cardContent:
        "We provide tailor-made web solution that align with your brand's vision. Our team ensures that every project incorporates unique functionalities, robust architecture, and custom features designed to meet specific business requirements while delivering optimal performance.",
      navigationLink: "/services/customwebsolutions",
    },
    {
      icon: Auditing,
      iconBackgroundColor: "#FFCC5A",
      cardTitle: "E-Commerce Development",
      cardContent:
        "Pixel Dot IT Solution delivers secure and scalable e-commerce solution that drive sales and improve customer retention. Our platforms are designed for smooth transactions, responsive layouts, and personalized user journeys, ensuring an excellent shopping experience across all devices.",
      navigationLink: "/services/ecommercedevelopment",
    },
    {
      icon: SecurityEdge,
      iconBackgroundColor: "#b92fb1",
      cardTitle: "Progressive Web Apps (PWA)",
      cardContent:
        "Leverage the power of Progressive Web Apps with Pixel Dot IT Solution. We build PWAs that combine the best of web and mobile apps, offering fast loading times, offline capabilities, and a native-app experience that boosts user engagement and retention.",
      navigationLink: "/services/pwa",
    },
    {
      icon: InfraStructure,
      iconBackgroundColor: "#59eed0",
      cardTitle: "CMS Development",
      cardContent:
        "Manage your content with ease using our CMS development services. Pixel Dot IT Solution creates flexible and scalable CMS solution that allow you to handle website content effortlessly, enabling quick updates, seamless integration, and secure management tailored to your business needs.",
      navigationLink: "/services/cmsdevelopment",
    },
    {
      icon: DataNetwork,
      iconBackgroundColor: "#4267d1",
      cardTitle: "Responsive Web Design",
      cardContent:
        "Our responsive web design services ensure your website delivers a seamless user experience across all devices. Pixel Dot IT Solution focuses on adaptive layouts, fast load times, and mobile-first designs that enhance accessibility and user engagement on any screen size.",
      navigationLink: "/services/responsivewebdesign",
    },
    {
      icon: Auditing,
      iconBackgroundColor: "#FF5A5A",
      cardTitle: "Web Performance Optimization",
      cardContent:
        "Optimize your website’s speed, security, and performance with Pixel Dot IT Solution. Our web performance optimization services ensure fast load times, improved SEO rankings, and robust security measures, providing users with a smooth and reliable browsing experience.",
      navigationLink: "/services/webperformanceoptimization",
    },
  ];

  const blogData = [
    {
      image:
        "https://spet-gatsby.envytheme.com/static/blog5-afbfbdfd40f8d35e591aa5f5c26423f8.jpg",
      date: "March 19, 2023",
      title: "Enhancing User Experience with UI/UX Best Practices:",
      detail:
        "Our team at Pixel Dot IT Solution collaborated with clients to redesign their web platforms with intuitive UI/UX solution. By conducting detailed user research and implementing modern design principles, we elevated user engagement and conversion rates, delivering seamless digital experiences.",
      link: "/blog/enhancing-user-experience-ui-ux-best-practices",
    },
    {
      image:
        "https://spet-gatsby.envytheme.com/static/blog4-8dbbb024b3be609d6b6c48f77ae4f095.jpg",
      date: "February 05, 2023",
      title: "Seamless Web App Migration for Scalable Growth:",
      detail:
        "We provided a robust web application migration strategy for our clients, ensuring zero downtime and enhanced performance. The migration to cloud-based solution allowed businesses to scale efficiently, with improved speed, security, and cost-effectiveness.",
      link: "/blog/seamless-web-app-migration-scalable-growth",
    },
    {
      image:
        "https://spet-gatsby.envytheme.com/static/blog3-a2e57eba995428852ec410f6a13ced57.jpg",
      date: "January 15, 2023",
      title: "Cost-Effective App Development Strategies:",
      detail:
        "At Pixel Dot IT Solution, we help clients reduce development costs without compromising quality. By leveraging modular coding practices, cross-platform development, and optimized resource allocation, we deliver high-performance apps tailored to specific business needs.",
      link: "/blog/cost-effective-app-development-strategies",
    },
    {
      image:
        "https://spet-gatsby.envytheme.com/static/blog2-c3809a2eb6a0baf6b5cb321ed76c29f2.jpg",
      date: "September 20, 2022",
      title: "Modernizing Websites with Headless CMS Solution:",
      detail:
        "Our experts transitioned client websites to headless CMS platforms, enhancing flexibility, scalability, and performance. The migration ensured faster loading times, improved SEO, and seamless content management, aligning with modern web development practices.",
      link: "/blog/modernizing-websites-headless-cms-solution",
    },
    {
      image:
        "https://spet-gatsby.envytheme.com/static/blog1-fb50e94f7547cede1bcc161297b3d313.jpg",
      date: "June 15, 2022",
      title: "Developing Scalable Mobile Apps for Growing Businesses:",
      detail:
        "Pixel Dot IT Solution recently delivered a scalable mobile app for a fast-growing enterprise, featuring real-time data synchronization and intuitive design. The app helped the client streamline operations and provided a robust digital presence in their industry.",
      link: "/blog/developing-scalable-mobile-apps-growing-businesses",
    },
  ];

  const nextSlide = () => {
    setSlideIndex(1);
  };
  const prevSlide = () => {
    setSlideIndex(0);
  };
  const isVisibleBlog = (index) => {
    if (index == 0 || index == 1 || index == 2) {
      if (slideIndex == 0) {
        return true;
      } else {
        return false;
      }
    }
    if (index == 3 || index == 4) {
      if (slideIndex == 1) {
        return true;
      } else {
        return false;
      }
    }
  };
  return (
    <>
      <Helmet>
        <title>
          Pixel Dot IT Solution | Leading Web & App Development Company
        </title>
        <meta
          name="description"
          content="Pixel Dot IT Solution specializes in website development, app development, UI/UX design, and custom web solutions. We deliver scalable, user-friendly digital solutions tailored to your business goals."
        />
        <meta
          name="keywords"
          content="Pixel Dot IT Solution, website development, app development, UI/UX design, e-commerce development, responsive web design, web performance optimization, PWA development, CMS development, custom web solutions"
        />
        <meta name="robots" content="index, follow" />
        <meta
          property="og:title"
          content="Pixel Dot IT Solution | Web & App Solutions Provider"
        />
        <meta
          property="og:description"
          content="Crafting cutting-edge digital experiences with robust website development, creative design, and scalable app solutions tailored to your business needs."
        />
        <meta property="og:url" content="https://www.pixeldot.in" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Pixel Dot IT Solution" />
        <meta property="og:locale" content="en_IN" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Pixel Dot IT Solution | Web & App Solutions Provider"
        />
        <meta
          name="twitter:description"
          content="High-quality website & app development, UI/UX design, and digital solutions tailored for your business at Pixel Dot IT Solution."
        />
        <link rel="canonical" href="https://www.pixeldot.in" />
      </Helmet>

      <div>
        <div className="main-section-container">
          <div className="container-box">
            <div className="first-section-container">
              <div>
                <h1 className="HomeBanner">
                  Leading <span>Web & App Solution</span> Provider
                </h1>
                <p className="HomeBanner-paragraph">
                  At Pixel Dot IT Solution, we specialize in crafting
                  cutting-edge digital experiences through exceptional website
                  development, creative website design, robust app development,
                  and intuitive UI/UX design. Our expert team is committed to
                  delivering scalable, user-friendly, and high-performing
                  digital solution tailored to meet your business needs.
                </p>
                <Link to="/aboutus" className="cta blogView">
                  <span className="cta-title blogView-title">Read More</span>
                  <svg
                    className="cta-svg blogView-svg"
                    width="13px"
                    height="10px"
                    viewBox="0 0 13 10"
                  >
                    <path d="M1,5 L11,5"></path>
                    <polyline points="8 1 12 5 8 9"></polyline>
                  </svg>
                </Link>
              </div>
              <div className="first-immage-container">
                <img className="bannerMainImg" src={banner} alt="banner" />
              </div>
            </div>
          </div>
        </div>
        <div className="main-section-container pb-5 second-main-section">
          <div className="ring-orange ring-orange2"></div>
          <div className="black-orange black-orange2"></div>
          <div className="container-box ">
            <div className="second-section-container">
              <img
                className="second-home-image"
                src={HomeImage}
                alt="HomeIllu"
              />
              <div>
                <div className="aboutText">
                  <h5>
                    Welcome to <span>Pixel Dot IT Solution</span>
                  </h5>
                  <p>
                    Your trusted partner for innovative web solution. At Pixel
                    Dot IT Solution, we deliver high-quality website
                    development, app development, UI/UX design, and
                    comprehensive digital solution tailored to your business
                    goals. We have quickly become the go-to partner for
                    organizations seeking digital excellence through responsive
                    websites, intuitive applications, and user-centric design
                    experiences.
                  </p>
                  <p>
                    Our mission is to help businesses establish a powerful
                    online presence, enhance user engagement, and boost
                    productivity by delivering scalable and future-ready web
                    solution.
                  </p>
                  <p>
                    With over 20 years of cumulative experience and a team of
                    certified professionals, Pixel Dot IT Solution possesses
                    deep expertise in crafting solution that meet today’s
                    business needs and scale seamlessly for future growth.
                  </p>
                  <p>
                    We collaborate closely with our clients to provide
                    integrated design and development services, ensure smooth
                    project delivery, and offer continuous maintenance and
                    enhancements to meet evolving digital demands.
                  </p>
                  <Link to="/aboutus" className="cta blogView">
                    <span className="cta-title blogView-title">Read More</span>
                    <svg
                      className="cta-svg blogView-svg"
                      width="13px"
                      height="10px"
                      viewBox="0 0 13 10"
                    >
                      <path d="M1,5 L11,5"></path>
                      <polyline points="8 1 12 5 8 9"></polyline>
                    </svg>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="main-section-container third-main-section">
          <img src={star} alt="star" className="starImg" />
          <img src={star} alt="star" className="starImg2" />
          <div className="container-box">
            <div className="third-section-container">
              <div className="text-center mb-3">
                <h4 className="section-main-title">
                  Services We can Help you with
                </h4>
                <p>
                  Analyze, Strategize, Develop, Optimize & 24x7
                  Post-Implementation Support
                </p>
              </div>
              <div className="home-service-container">
                {serviceHomePageJson?.map((data, index) => {
                  return (
                    <div className="custom-service-card" key={index}>
                      <div className="custom-service-card-inner-div">
                        <img
                          src={star}
                          alt="star"
                          className="custom-service-card-image"
                        />
                        <div
                          className="custom-service-icon-main"
                          style={{ backgroundColor: data?.iconBackgroundColor }}
                        >
                          <data.icon className="custom-service-icon" />
                        </div>
                        <div>
                          <Link
                            to={data?.navigationLink}
                            className="custom-service-link"
                          >
                            {data?.cardTitle}
                          </Link>
                        </div>
                        <div className="custom-service-text">
                          {data?.cardContent.slice(0, 200) + "..."}
                        </div>
                        <div>
                          <Link
                            to={data?.navigationLink}
                            className="cta blogView"
                          >
                            <span className="cta-title blogView-title">
                              Learn More
                            </span>
                            <svg
                              className="cta-svg blogView-svg"
                              width="13px"
                              height="10px"
                              viewBox="0 0 13 10"
                            >
                              <path d="M1,5 L11,5"></path>
                              <polyline points="8 1 12 5 8 9"></polyline>
                            </svg>
                          </Link>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
        <div className="main-section-container fourth-main-section">
          <div className="container-box">
            <div className="third-section-container">
              <div className="text-center mb-3">
                <h4 className="section-main-title">Industries We Serve</h4>
                <p>
                  With our expertise in web development, app solution, and UI/UX
                  design, we cater to a diverse range of industries.
                </p>
              </div>
              <div className="industry-container">
                <div className="d-flex industry-box">
                  <div className="industriesBox">
                    <p>Manufacturing</p>
                    <div className="industriesBoxIconbg">
                      <div className="industry-icon-box">
                        <Manufacturing className="industry-icons" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="d-flex industry-box">
                  <div className="industriesBox">
                    <p>Healthcare</p>
                    <div className="industriesBoxIconbg">
                      <div className="industry-icon-box">
                        <Healthcare className="industry-icons" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="d-flex industry-box">
                  <div className="industriesBox">
                    <p>Automobile</p>
                    <div className="industriesBoxIconbg">
                      <div className="industry-icon-box">
                        <AUtomobile className="industry-icons" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="d-flex industry-box">
                  <div className="industriesBox">
                    <p>Financial Services</p>
                    <div className="industriesBoxIconbg">
                      <div className="industry-icon-box">
                        <Banking className="industry-icons" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="d-flex industry-box">
                  <div className="industriesBox">
                    <p>Real Estate</p>
                    <div className="industriesBoxIconbg">
                      <div className="industry-icon-box">
                        <RealEstate className="industry-icons" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="d-flex industry-box">
                  <div className="industriesBox">
                    <p>FinTech</p>
                    <div className="industriesBoxIconbg">
                      <div className="industry-icon-box">
                        <FinanceIcon className="industry-icons" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="d-flex industry-box">
                  <div className="industriesBox">
                    <p>Insurance</p>
                    <div className="industriesBoxIconbg">
                      <div className="industry-icon-box">
                        <Insurance className="industry-icons" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="d-flex industry-box">
                  <div className="industriesBox">
                    <p>Investment</p>
                    <div className="industriesBoxIconbg">
                      <div className="industry-icon-box">
                        <OurRecentStory className="industry-icons" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="main-section-container third-main-section">
          <img src={star} alt="star" className="starImg" />
          <img src={star} alt="star" className="starImg2" />
          <div className="container-box">
            <div className="blog-section-container desktop-blog-section">
              <button
                className={`${
                  slideIndex == 0 ? "disabled-blog-button" : ""
                } left-side-blog-button side-blog-button`}
                onClick={prevSlide}
              >
                <Arrow className="blog-arrow" />
              </button>
              <button
                className={`${
                  slideIndex == 1 ? "disabled-blog-button" : ""
                } right-side-blog-button side-blog-button`}
                onClick={nextSlide}
              >
                <Arrow className="blog-arrow" />
              </button>
              <div className="third-section-container">
                <div className="text-center mb-3">
                  <h4 className="section-main-title">Our Recent Story</h4>
                  <p>
                    At Pixel Dot IT Solution, our clients' success defines our
                    achievements. We craft tailored web solution, cutting-edge
                    applications, and seamless UI/UX designs that empower
                    businesses to scale faster, engage customers, and stay ahead
                    in the competitive digital landscape.
                  </p>
                </div>
                <div className="our-stories-container">
                  {blogData?.map((data, index) => {
                    return (
                      <div
                        key={index}
                        className={`${
                          isVisibleBlog(index) ? "active-anim" : "slide"
                        } our-stories-box`}
                      >
                        <div className="blogMain">
                          <img
                            className="blogImg"
                            src={data?.image}
                            alt="img"
                          />
                          <div className="blogText">
                            <p>{data?.date}</p>
                            <h5>{data?.title}</h5>
                            <div className="blog-content-div">
                              {data?.detail.slice(0, 200) + "..."}
                            </div>
                            <Link to={data?.link} className="cta blogView">
                              <span className="cta-title blogView-title">
                                Read More
                              </span>
                              <svg
                                className="cta-svg blogView-svg"
                                width="13px"
                                height="10px"
                                viewBox="0 0 13 10"
                              >
                                <path d="M1,5 L11,5"></path>
                                <polyline points="8 1 12 5 8 9"></polyline>
                              </svg>
                            </Link>
                            <div className="ring-orange"></div>
                            <div className="black-orange"></div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
            <div className="mobile-blog-container">
              <div className="third-section-container">
                <div className="mobile-container">
                  {blogData?.map((data, index) => {
                    return (
                      <div
                        key={index}
                        className="our-stories-box mobile-stories-box"
                      >
                        <div className="blogMain">
                          <img
                            className="blogImg"
                            src={data?.image}
                            alt="img"
                          />
                          <div className="blogText">
                            <p>{data?.date}</p>
                            <h5>{data?.title}</h5>
                            <div className="blog-content-div">
                              {data?.detail.slice(0, 200) + "..."}
                            </div>
                            <Link to={data?.link} className="cta blogView">
                              <span className="cta-title blogView-title">
                                Read More
                              </span>
                              <svg
                                className="cta-svg blogView-svg"
                                width="13px"
                                height="10px"
                                viewBox="0 0 13 10"
                              >
                                <path d="M1,5 L11,5"></path>
                                <polyline points="8 1 12 5 8 9"></polyline>
                              </svg>
                            </Link>
                            <div className="ring-orange"></div>
                            <div className="black-orange"></div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="main-section-container newslatter newsletter-main">
          <div className="container-box">
            <div className="third-section-container newsletter-main-section">
              <div className="newsmain">
                <h6 className="section-main-title">
                  Book your Interested Session
                </h6>
                <div className="newsInput">
                  <input type="text" placeholder="Enter you business email" />
                  <button>Sign Up</button>
                </div>
                <p>
                  Schedule a free session with our technical experts to explore
                  the technologies and solution we offer, tailored to your
                  business needs.
                </p>
              </div>
              <div className="newsImg">
                <img
                  className=""
                  src="https://images.unsplash.com/photo-1515965885361-f1e0095517ea?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80"
                  alt="img"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
